import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';
import { LanguageService } from '../language/language.service';

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor(private http: HttpClient, private languageService: LanguageService) {}

  get(){
    const lang = this.languageService.getLanguage();
    return this.http.get(`${environment.apiUrl}admin/slider?lang=${lang}`);
  }

  updatePositions(items: any) {
    return this.http.post(environment.apiUrl +  'admin/slider/update-positions', items);
  }

  delete(id: number){
    return this.http.delete(environment.apiUrl +  'admin/slider/delete/' + id );
  }

  update(data: any) {
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/slider/store?lang=${lang}`, data);
  }

  store(data: any) {
    const lang = this.languageService.getLanguage();
    return this.http.post(`${environment.apiUrl}admin/slider/update?lang=${lang}`, data);
  }
  

}
